import React from 'react';

const InputNumberField = props => {
  const { inputId, value, onChange, editMode, disabledMode } = props;

  const nullSafeValue = (value === null) ? '' : value;

  const handleChange = value => {
    value = (value === '') ? null : Number(value);
    onChange(value);
  }

  return (
    <div className="parkchirp--input-number-field">
      {editMode ?
        <input
          type="number"
          id={inputId}
          value={nullSafeValue}
          onChange={event => handleChange(event.target.value)}
          disabled={disabledMode}
        />
        :
        <span>{nullSafeValue}</span>
      }
    </div>
  );
};

export default InputNumberField;
